
//var audio = document.createElement('audio');
//var canPlayOgg = audio.canPlayType('audio/ogg');
//var ogvstate = 'none';
//var ogv_js = null;
//if (!canPlayOgg) {
//    console.log('we need to import ogv')
//    ogvstate = 'loading';
//    ogv_js = document.createElement("script");
//    ogv_js.type = "text/javascript";
//    ogv_js.src = "https://cdn.jsdelivr.net/npm/ogv@1.9.0/dist/ogv.js"
//    document.body.appendChild(ogv_js);
//}

const PIGE_DURATION = 60

function replaceHash (newhash) {
    let newurl = window.location.toString()
    if (window.location.hash == '') {
        newurl += '#' + newhash;
    } else {
        newurl = newurl.replace(/#.*/, '#' + newhash);
    }
    history.replaceState({url:newurl}, "", newurl);
}


export function changeFavicon(src) {
    //document.head = document.head || document.getElementsByTagName('head')[0];
    var link = document.createElement('link'),
        oldLink = document.getElementById('dynamic-favicon');
    link.id = 'dynamic-favicon';
    link.rel = 'shortcut icon';
    link.href = src;
    if (oldLink) {
        document.head.removeChild(oldLink);
    }
    document.head.appendChild(link);
}


/*
 * This Class connect to a omaWebServer with websockets
 * It will create a singleton, any other instance you can create with new OmaWebsocketClient() will return the same instance
 * You add a callback that will be called on a channel message with : (new OmaWebsocketClient).handler('12', function(message){console.log(message)}
 * You can add any handler you want but not remove them as this time
 * TODOs:
 * - Authorize handlers removing
 * - Set a handler to all messages (like the debug one)
 */
export class OmaWebsocketClient {
    constructor (radioHost, wssPort) {
        /* Singleton */
        const instance = this.constructor.instance;
        if (instance) {
            return instance;
        }
        this.constructor.instance = this;
        /*   Actual Constructor */
        /* string to boolean */
        this.host  = radioHost
        this.port  = wssPort

        this.channelHandlers = {}
        this.channelNumber = 105
        this.websocket = null

        this.reconnectTimeout = null

        if (this.debug) {
            this.setupDebug()
        }
        this.startWebsockets()
    }

    /* Add a handler to a channel */
    handler(channel, callback){
        /* Test channel validity */
        if (! this.isChannelValid(channel)) {
            throw 'Channel '+channel+' is not valid'
        }
        /* Initialize handler array if needed */
        if (!(channel in this.channelHandlers)) {
            this.channelHandlers[channel] = []
        }
        /* Add the handler */
        this.channelHandlers[channel].push(callback)
    }

    /* Test if the channel number is supported */
    isChannelValid (channel) {
        var number = typeof(channel) != 'number' ? channel.slice(1) : channel
        return number >= 0 && number < this.channelNumber
    }


    /* Create websocket connection */
    startWebsockets(){
        window.WebSocket = window.WebSocket || window.MozWebSocket
        this.websocket = new WebSocket(this.host+':'+this.port, 'oma-protocol');
        this.websocket.onopen = () => {
            console.log('websocket opened')
        }
        this.websocket.onerror = (e) => {
            console.error('websocket error', e)
            this.restartLater()
            this.websocket.close()
        }
        this.websocket.onmessage = (message) => {
            console.log('debug oma-lib.ws : websocket message : '+message.data)
            if (message.data == '' || message.data == 'alive'){return}
            else if (message.data == 'ko') {
                console.error('WS ko');
            } else {
                var data = JSON.parse(message.data)
                this.gotNewWs(data)
            }
        }

        this.websocket.onclose = () => {
            console.log('websocket closed')
            this.restartLater()
        }
    }

    gotNewWs (data) {
        /* Pass to the handlers if defined */
        for (var channel in data) {
            var channelNum = channel.slice(2) /* On récupère un chaine genre ch4 */
            if (channelNum in this.channelHandlers) {
                for (var handler in this.channelHandlers[channelNum]) {
                    this.channelHandlers[channelNum][handler](data[channel])
                }
            }
        }
        /* Interractive format */
        if ('ch' in data) {
            channelNum = data['ch']
            for (handler in this.channelHandlers[channelNum]) {
                this.channelHandlers[channelNum][handler](data)
            }
        }
    }

    restartLater() {
        if (this.reconnectTimeout != null) {
            clearTimeout(this.reconnectTimeout)
        }
        this.reconnectTimeout = setTimeout(() => {
            this.startWebsockets()
            this.reconnectTimeout = null
        }, 5000)
    }

    /* This function is used to send data to the server */
    send(data){
        console.log('Debug sending: ' + data)
        if (this.websocket.readyState != 1) {
            throw ("Cant send message: ws state is " + this.websocket.readyState)
        }
        this.websocket.send(data)
    }
}

export class OmaFiche {
    constructor (content) {
        this.data = {}
        this.actions = {} /* Tag actions */
        this.parse(content)
    }

    parse (content) {
        var lines = content.split('\n')
        for(var i = 0;i < lines.length;i++){
            var line = lines[i].split(':')
            var key = line[0].trim()
            var value = lines[i].slice(lines[0].length+1).trim()
            this.data[key] = value
            if (key.match(/Tag\d/)) { /* contextual tags managment */
                var beginTime = Number(key.slice(3))
                var infos = value.split(' ')
                var endTime = beginTime + Number(infos[1])
                if (! (beginTime in this.actions)) { this.actions[beginTime] = [] }
                this.actions[beginTime].push({'ch': infos[0], 'msg': infos[2]}) /* Display contextual item */
                if (! (endTime in this.actions)) { this.actions[endTime] = [] }
                this.actions[endTime].push({'ch':infos[0], 'msg': ''}) /* Hide contextual item */
            }
        }
    }

    get (key) {
        return this.data[key]
    }
}



/*
 * This Class is a sound replayer with no interface.
 * It implements the singleton pattern so there is only one player on a page.
 * Algorithm:
 * When a stream is started, the next is added and its loading is scheduled 15s before the end of this one.
 * If the user move in the stream, the loading date is computed again (how do we cancel the previus?)
 * 15s before the stream end, the next starts loading
 * On the stream end, the next starts
 * And it starts again.
 */
export class OmaPlayer{
    constructor(radioHost, omaWebsocket){
        this._radioHost = radioHost

        /* The oma websocket object */
        this._ows = omaWebsocket
        if (this._ows) {
            this._ows.handler('100', (data) => {this.got_new(data)})
        }

        /* Api contact */
        this.api = new OmaApi(this._radioHost)

        /* player states and modes. Keys and values must be indentical */
        var _this = this
        this.STATES = {
            LOADING: 'LOADING',
            PLAYING: 'PLAYING',
            PAUSED: 'PAUSED',
            IDLE: 'IDLE',
            ERROR: 'ERROR',
            WAITING_FOR_USER: 'WAITING_FOR_USER',
            get isLoading() { return _this._state == this.LOADING },
            get isPlaying() { return _this._state == this.PLAYING },
            get isPaused()  { return _this._state == this.PAUSED },
            get isIdle()    { return _this._state == this.IDLE },
            get isError()   { return _this._state == this.ERROR },
            get isWaitingForUser()   { return _this._state == this.WAITING_FOR_USER },
        }
        this.TYPES = {
            DIRECT: 'DIRECT',
            REPLAY: 'REPLAY',
            PODCAST: 'PODCAST',
            NONE: 'NONE',
            get isDirect()  { return _this._type == this.DIRECT},
            get isReplay()  { return _this._type == this.REPLAY},
            get isPodcast() { return _this._type == this.PODCAST},
            get isNone()    { return _this._type == this.NONE},
        }


        /* For txt pige indexing */
        this._textPigeBaseIndex = null
        this._ows.handler(101, (data) => {
            _this._gotNewTxtPige(_this, data)
        })
        this._ows.handler(104, (data) => {
            _this._gotPodcastTxt(_this, data)
        })
        this._ows.handler('R0', () => {
            this._txtReplayEmpty = false
        })
        this.onplay = null
        this._pigeIndexer = new OggPigeIndex(this._radioHost)

        /* setters */
        Object.defineProperty(this, "paused", {
            set : (value) => {
                if (typeof(value) != 'boolean')
                    throw 'paused: value must be a boolean'
                this._paused = value
                if (this.onpaused) this.onpaused(value)
            },
            get: () => {
                return this._paused
            },
        })
        Object.defineProperty(this, "volume", {
            set : (volume) => {
                if (volume < 0 || volume > 1 || isNaN(volume))
                    throw 'Volume "'+volume+'" is not between 0 and 1'
                this._volume = volume
                if (this._current_stream != null && Object.prototype.hasOwnProperty.call(this._current_stream, 'player'))
                    this._current_stream.player.volume = volume
                localStorage.setItem('omaVolume', volume)
                if (this.onvolume) this.onvolume(volume)
            },
            get: () => {
                return this._volume
            },
        })
        Object.defineProperty(this, "muted", {
            set : (value) => {
                if (typeof(value) != 'boolean') {
                    throw 'muted: value must be a boolean'
                }
                if (this._current_stream != null && Object.prototype.hasOwnProperty.call(this._current_stream, 'player')) {
                    this._current_stream.player.muted = value
                }
                this._muted = value
                localStorage.setItem('omaMuted', value)
                if (this.onmuted) this.onmuted(value)
            },
            get: () => {
                return this._muted
            },
        })
        Object.defineProperty(this, "state", {
            set : (value) => {
                if (! (value in this.STATES)) {
                    throw 'State: value "' + value + '" is not valid'
                }
                this._state = value
                if (this.onstate) this.onstate(value)
            },
            get: () => {
                return this._state
            },
        })
        Object.defineProperty(this, "type", {
            set : (value) => {
                if (! (value in this.TYPES)) {
                    throw 'Type: value "' + value + '" is not valid'
                }
                this._type = value
                if (this.ontype) this.ontype(value)
            },
            get: () => {
                return this._type
            },
        })

        this.volume = parseFloat(localStorage.getItem('omaVolume')) || 1 /* Sound volume */
        this.muted  = localStorage.getItem('omaMuted') == 'true'
        this.paused = false

        this.reinit()
    }

    /* Create audio element from src */
    _createPlayerFromOgg(src) {
        /* This function creates an audio player with ogg and mp3 sources.
         */
        console.log('Debug _createPlayerFromOgg:', src)

        var audio = document.createElement('audio');

        var _this = this
        audio.onerror = e => {
            console.log('yes we got an error')
            _this.state = _this.STATES.ERROR;
            console.error(e)
        };

        if (audio.canPlayType('audio/ogg')) {
            this._addSource(audio, src, 'audio/ogg');
        } else {
            this._addSource(audio, src.slice(0,-3).replace(/\/ogg\//, '/mp3/') + 'mp3', 'audio/mpeg');
        }

        audio.muted = this.muted
        audio.volume = this.volume
        return audio;
    }

    /* Add source to an audio element */
    _addSource(audio, src, type) {
        let source = document.createElement('source')
        source.type = type;
        source.src = src;
        audio.appendChild(source);
        audio.src = src
    }



    _destroyStream(stream) {
        if (stream != null && Object.prototype.hasOwnProperty.call(stream, 'player')) {
            try {
                stream.player.pause();
                /* The next line fetch / as a media src... */
                //stream.player.src = '';
            } catch (e) {
                console.error('error on destroying stream', e)
            }
            stream.player.onerror = null
            stream.player.ontimeupdate = null
            stream.player.ontimeupdate = () => {
                console.error('A deleted stream is playing!')
            }
            //delete stream.player;
        }
        this._current_stream = {}
    }

    reinit (hard=true) {
        if (hard) {
            this._destroyStream(this._current_stream)
            this._destroyStream(this._loading_stream)
            this._ask_end = null
        }

        this._nextPigeReplayTimeout = null /* Timer returned by setInterval */
        this.currentTime = null
        this._need_to_play = null   /* The date that user asked to play */
        this._audioReplayAskedPos = null /* The pos we asked for. Useful in double replay detection */
        this.state = this.STATES.IDLE
        this.type = this.TYPES.NONE
        this.currentFile = ''
        this.errorMsg= ''
    }
    // TODO on stream error/stop?

    _start_current_stream(fromStart=false, wait=false){
        console.log('Debug _start_current_stream():', fromStart, wait) 
        if (this._current_stream == null || !Object.prototype.hasOwnProperty.call(this._current_stream, 'player')) { return false}
        console.log('need to play ', this._need_to_play, this._current_stream.need_to_play)
        var player = this._current_stream.player
        if (fromStart && !wait) {
            player.onplay = () => {
                console.log('set playing')
                this.state = this.STATES.PLAYING
                if (this.onplay) this.onplay()
            }
            player.play()
            this._check_for_next()
            return true
        }
        /* Is this a perimed stream (from another request) */
        else if (this._current_stream.need_to_play != null && this._current_stream.need_to_play != this._need_to_play) {
            return false
        }
        /* Is this a perimed stream (too old) */
        else if (this._current_stream.need_to_play != null && this._current_stream.need_to_play + PIGE_DURATION < this._need_to_play) {
            console.error("Requested date not found in current stream")
            return false
        }
        /* Are we too much in the future */
        else if (this._current_stream.timestamp > this._need_to_play) {
            return false
        }
        /* Is this the stream we are waiting for? */
        else if (this._need_to_play >= this._current_stream.timestamp){
            var currentTime = this._need_to_play - this._current_stream.timestamp
            console.log('starting current stream at '+currentTime + ' seconds on '+player.duration)
            player.currentTime = currentTime
            if (!wait) {
                player.onplay = () => {
                    this._need_to_play = null
                    console.log('set playing')
                    this.state = this.STATES.PLAYING
                    if (this.onplay) this.onplay()
                }
                /* we pause the player so play() will always trigger the onplay event */
                player.pause()
                player.play()
            } else {
                this.state = this.STATES.WAITING_FOR_USER
            }
            this._check_for_next()
            return true
        } else {
            console.log('We are in some unknown state....')
        }
        return false
    }

    /* The user input : play/pause */
    play_pause() {
        console.log('Debug play_pause():') 
        if (this.state == this.STATES.IDLE) {
            this.playDirect()
            return true
        }
        /* No stream exists, no date have been set */
        if(this._current_stream == null)
            return false

        var stream = this._current_stream.player
        if (stream && (this.STATES.isWaitingForUser || stream.paused)) {
            stream.play()
            this.paused = false
            this.state = this.STATES.PLAYING
            if (this.onplay) this.onplay()
        } else {
            stream.pause()
            this.paused = true
            this.state = this.STATES.PAUSED
        }
        return true
    }

    playDirect(wait=false) {
        this.reinit()
        this.type = this.TYPES.DIRECT
        this.state = this.STATES.LOADING
        replaceHash('direct')

        console.log('Debug playDirect')
        try {
            var stream = this._createPlayerFromOgg(this._radioHost+'/direct.ogg', false)
            this._current_stream = {'player': stream}
        } catch (e) {
            console.log('Impossible de charger le son du podcast, essayez le site « simple »')
            console.error(e)
            this.state = this.STATES.ERROR;
            return;
        }
        if (this.onplay) this.onplay()



        var _this = this
        if (!wait) {
            stream.onplay = ()=>{
                /* Cleaning replay */
                this.state = this.STATES.PLAYING
            }
            stream.play()
        } else {
            this.state = this.STATES.WAITING_FOR_USER
        }
        stream.ontimeupdate = () => {
            //if (!_this.paused) {
            //    _this.state = _this.STATES.PLAYING
            //}
            _this.currentTime = Math.round(Date.now() / 1000)
        }
        stream.onended = () => { /* direct was interrupted ! */
            _this.playDirect()
        }
        stream.onabort = () => {
            //console.error('abort')
        }
        stream.onstalled = () => {
            console.error('stalled')
        }
        //stream.onwaiting= () => {
        //    console.error('waiting')
        //}
        stream.onerror = () => {
            console.error('error trouvée')
            _this.state = _this.STATES.ERROR
            _this.errorMsg = 'Impossible de jouer le direct'
        }
    }

    /******************************************************************* Podcast play *********************************************************/
    playPodcast (simpleName, prettyName=null, serieName=null, serieTitre=null, wait=false, time=0) {
        console.log('Debug playPodcast')
        this.reinit()
        this.currentFile = simpleName
        replaceHash(simpleName)
        this.type = this.TYPES.PODCAST
        if (wait)
            this.state = this.STATES.WAITING_FOR_USER
        else
            this.state = this.STATES.LOADING

        try {
            var stream = this._createPlayerFromOgg(this._radioHost+'/soundbase/ogg/'+simpleName+'.ogg')
            stream.currentTime = time
            this._current_stream = {'player': stream, 'prettyName': prettyName, 'serieName': serieName, 'serieTitre': serieTitre}
            stream.load()
        } catch (e) {
            console.log('Impossible de charger le son du podcast, essayez le site « simple »')
            console.error(e)
            this.state = this.STATES.ERROR;
            return;
        }
        if (prettyName === null) {
            this.api.getFile('/soundbase/fic/'+simpleName+'.fic',
            (data) => {
                var rx = /\nTextePod : (.*)\n/g;
                var arr = rx.exec(data);
                if (arr === null) {
                    console.warn('No TextePod found in fic: '+simpleName)
                } else {
                    this._current_stream.prettyName = arr[1]; 
                }
            }, (error) => {
                console.log(error)
            })
        }

        var _this = this
        stream.onplay = ()=>{
            this.state = this.STATES.PLAYING
            if (this.onplay) this.onplay()
            try {
            //this._ows.send('getTagLst ' + simpleName)
            } catch (e) {
                console.error(e)
            }
        }
        stream.ontimeupdate = () => {
            replaceHash(simpleName + ':' + Math.round(stream.currentTime));
            _this.currentTime = Math.round(_this._current_stream.player.currentTime)
        }
        stream.onended = () => {
            setTimeout(() => {
                _this.playDirect()
            }, 5000)
        }

        if (!wait) stream.play()

    }

    _gotPodcastTxt (_this, data) {
        console.log('New podcast txt :' + data.tps)
        _this._current_stream.tps = data.tps
        _this._current_stream.next_index = 0
        _this._getPodcastTime(_this)
    }

    _getPodcastTime (_this) {
        console.log('_getPodcastTime')
        /* If replay stopped for some reason */
        if (_this._type != this.TYPES.PODCAST)
            return;
        /* If we have no next tag */
        else if (_this._current_stream.tps.length < _this._current_stream.next_index+2) {
            return;
        }
        const next_time = _this._current_stream.tps[_this._current_stream.next_index]
        const now = _this.currentTime || null
        if (now === null) {
            console.log('try again in 2 sec')
            window.setTimeout(()=>{_this._getPodcastTime(_this)}, 2000)
        } else if ( now+1 > next_time  ) {
            /* If it is time to show the next podcast */
            _this._ows.send('getTag ' + _this.currentFile+ ' ' + _this._current_stream.next_index)
            _this._current_stream.next_index += 1
            _this._getPodcastTime(_this)

        } else {
            const delay = Math.max(next_time-now, 1)
            console.log('try again in ', delay)
            window.setTimeout(()=>{_this._getPodcastTime(_this)}, delay*1000)
        }
    }

    /******************************************************************* Audio replay *********************************************************/

    /* User input : set date. Date is a unix timestamp*/
    setDate(date, prettyName=null, wait=false, end=null){
        console.log('Debug setDate(): '+date) 
        if (typeof(date) != 'number' && date < 0){
            console.warn('setDate(): invalid timestamp')
            return
        }
        replaceHash(date)
        this.reinit(false)
        this.type = this.TYPES.REPLAY
        this.state = this.STATES.LOADING
        this._need_to_play = date
        this._ask_end = end
        this.currentTime = date
        this._current_stream.prettyName = prettyName; 
        if (!this._start_current_stream(false, wait)) { /* look for the time here */
            this._destroyStream(this._current_stream)
            this._current_stream = this._loading_stream
            this._loading_stream = null;
            if (this._current_stream)
                this._current_stream.prettyName = prettyName; 
            if (!this._start_current_stream(false, wait)) { /* and here */
                this._destroyStream(this._current_stream)
                this._current_stream = null;
                this._pigeIndexer.getOggFileOf(date, (timestamp, filename) => {
                    if (this._need_to_play == date) { /* Check if asked replay has changed since */
                        console.log('Debug set _current_stream')
                        this._current_stream = this.create_replayer(timestamp, filename, date, wait)
                        this._start_current_stream(false, wait)
                        this._current_stream.prettyName = prettyName; 
                    }
                }, errorMsg =>{
                    this.state = this.STATES.ERROR
                    if (errorMsg)
                        this.errorMsg = errorMsg
                })
            }
        }
    }

    setDateHuman(date, time){
        if (date == '' || time == ''){
            console.warn('setDateHuman(): empty date or time')
            alert('Remplissez la date et l’heure avant de lancer la réécoute :)')
            return
        }
        console.log('Debug setDateHuman(): ', date, time) 
        var replay_timestamp = (new Date(date + ' ' + time)).getTime() / 1000
        if (!replay_timestamp) {console.error('timestamp invalid');return}
        this.setDate(replay_timestamp)
    }

    _on_end(thisReplacement){
        var _this = thisReplacement ? thisReplacement : this
        _this.state = this.STATES.LOADING
        console.log('Debug _on_end():') 
        if (_this._current_stream === null ) { return }
        if (_this._loading_stream === null)
            throw "Next stream was not found!"
        _this._current_stream = _this._loading_stream
        _this._loading_stream = null
        _this._start_current_stream(true)
    }

    forward (amount) {
        if (this.TYPES.isReplay || this.TYPES.isDirect) {
            var seconds = this.currentTime + Number(amount)
            if (seconds === null) return;
            this.setDate(seconds)
        } else if (this.TYPES.isPodcast) {
            this._current_stream.player.currentTime += amount
        } else {
            console.error('Invalid state for forward ' + this._type)
        }
    }

    /* Create player and its environment from a pige file */
    create_replayer (file_timestamp, filename, need_to_play=null, wait=false) {
        const data = {timestamp: file_timestamp, filename:filename, need_to_play: need_to_play}
        console.log('Debug create_replayer():', file_timestamp, filename, need_to_play, wait) 

        /* Create the player */
        try {
            data.player = this._createPlayerFromOgg(this._radioHost+'/soundbase/pige/'+filename+'.ogg')
        } catch (e) {
            console.log('Impossible de charger le son')
            console.error(e)
            this.state = this.STATES.ERROR;
            return;
        }

        /* Start stream loading */
        data.player.load()
        data.player.oncanplay = () => {
            console.log('replayer loaded')
            if (need_to_play) {
                if (wait) {
                    this.state = this.STATES.WAITING_FOR_USER
                } else {
                    data.player.play()
                }
            }
        }
        data.player.onplay = () => {
            this.state = this.STATES.PLAYING
            if (this.onplay) this.onplay()
        }

        /* Be notified on streams end */
        var _this = this
        data.player.onended = () => { _this._on_end(_this) }
        data.player.ontimeupdate = () => {
            _this.currentTime = Math.floor(_this._current_stream.timestamp + _this._current_stream.player.currentTime)
            replaceHash(_this.currentTime);
        }

        return data
    }


    _check_for_next(){
        console.log('Debug _check_for_next():') 
        /* Only check for next if there is a current stream */
        if (! this._current_stream) { return }

        /* If we don’t know the stream duration, we come back in 2 secs */
        else if (isNaN(this._current_stream.player.duration))
            window.setTimeout(()=>{this._check_for_next()}, 2000)

        /* If the file is not available on the server */
        else if ( this._current_stream.need_to_play > this._current_stream.timestamp + this._current_stream.player.duration) {
            this.state = this.STATES.ERROR
            this.errorMsg = 'La date que vous avez demandé n’est pas disponible à la réécoute :('
        }
        /* If the stream is almost at the end, we get the next from internet */
        else if (this._current_stream.player.duration - this._current_stream.player.currentTime < 40) {
            console.log('_check_for_next: get the next!')
            this._pigeIndexer.getNextOggFileOf(this._current_stream.timestamp, (timestamp, filename) => {
                this._loading_stream = this.create_replayer(timestamp, filename, null, true)
                console.log('Debug set _loading_stream')
            }, () =>{
                // TODO un peu de blanc le temps que ça arrive ?
                //window.setTimeout(this._check_for_next(), 10000)
            })
            /* if the stream is more than a minute from the end, we come back later */
        } else {
            window.setTimeout(()=>{this._check_for_next()}, (this._current_stream.player.duration - this._current_stream.player.currentTime - 40)*1000)
        }
    }

    /********************************************** Text Pige ********************************************/

    _initTxtReplay (date) {
        console.log('Debug _initTxtReplay():') 
        this._txtReplayEmpty = true
        this._syncTxtPige(date)
    }

    /* data is the text event */
    _gotNewTxtPige (_this, data) {
        var now = _this.currentTime
        console.log('Debug _gotNewTxtPige(): at '+now+' in '+_this.state) 
        if (isNaN(now)) { setTimeout(() => {_this._gotNewTxtPige(_this, data)}, 1000) } /* come back when we got track of time */
        else if (data.status != 'Ok') { console.warn('Error getting text replay') ; _this.state = _this.STATES.ERROR } //TODO restart replay?
        else {
            this._textPigeBaseIndex = data /* save this for later indexing sync */

            if (Math.abs(now - data.N) <= 1) { /* Time to show this message is close */
                _this._ows.send('txtReplayInfo ' + (parseInt(data.pos)+1))
                setTimeout(() => { _this._askTxtPige(_this, parseInt(data.pos) + 3)}, 1000) /* get the next batch of pos in 1sec*/
            }
            else if (Math.abs(now - data.C) <= 1) { /* Time to show this message is close */
                _this._ows.send('txtReplayInfo ' + data.pos)
                setTimeout(() => { _this._gotNewTxtPige(_this, data) }, (data.N - now - 1)*1000)
            }
            else if (Math.abs(now - data.P) <= 1) { /* Time to show this message is close */
                _this._ows.send('txtReplayInfo ' + (parseInt(data.pos)-1))
                setTimeout(() => { _this._gotNewTxtPige(_this, data) }, (data.C - now - 1)*1000)
            }
            else if (data.P < now && now < data.C) {
                if (_this._txtReplayEmpty) _this._ows.send('txtReplayInfo ' + (parseInt(data.pos)-1))
                setTimeout(() => { _this._gotNewTxtPige(_this, data) }, Math.max(data.C - now - 1, .5)*1000)
            }
            else if (data.C < now && now < data.N) {
                if (_this._txtReplayEmpty) _this._ows.send('txtReplayInfo ' + data.pos)
                setTimeout(() => { _this._gotNewTxtPige(_this, data) }, Math.max(data.N - now - 1, .5)*1000)
            }
            else if (now < data.P) { /* we got prevision, not useful rigth now */
                setTimeout(() => { _this._gotNewTxtPige(_this, data) }, Math.max(data.P - now - 1, .5)*1000)
            }
            else if (now < data.P || (data.N < now && data.N != 0)) {
                _this._syncTxtPige(now)
            } else {
                console.log('txt replay is in impossible condition')
            }
        }
    }

    _askTxtPige (_this, pos) {
        _this._ows.send('txtReplayGet ' + pos)
    }

    _syncTxtPige (unixTime) {
        if (this._textPigeBaseIndex === null) {
            this._ows.send('txtReplaySync ' + unixTime)
        } else {
            var delta = this._textPigeBaseIndex.C - unixTime
            const letter = delta > 0 ? 'P' : 'N'
            delta = Math.abs(delta)
            this._ows.send('txtReplayGet' + letter + ' ' + this._textPigeBaseIndex.pos + ' ' + delta)
        }
    }
}

export class OmaReplayer {
    constructor (radioHost) {
        /* Singleton */
        const instance = this.constructor.instance;
        if (instance) { return instance }
        this.constructor.instance = this;
        
        this.radioHost = radioHost
    }
}

export class OggPigeIndex {
    constructor (radioHost) {
        /* Singleton */
        const instance = this.constructor.instance;
        if (instance) { return instance }
        this.constructor.instance = this;
        this.api = new OmaApi(radioHost)
    }

    getOggFileOf (timestamp, callback) {
        const ts = Math.floor(timestamp/60)*60;
        callback(ts, ts)
    }

    getNextOggFileOf (timestamp, callback) {
        const ts = Math.floor(timestamp/60)*60 + 60
        callback(ts, ts)
    }
}


export class OmaApi {
    constructor (radioHost) {
        /* Singleton */
        const instance = this.constructor.instance;
        if (instance) { return instance }
        this.constructor.instance = this
        this._radioHost = radioHost
    }

    get (url, callback=null, errorCallback=null) {
        fetch(this._radioHost + url)
        .then(response => response.json())
        .then(data => {
            if (data.status != 200 && errorCallback) {
                errorCallback(data.msg)
            } else if (callback)
                callback(data.data)
        })
        .catch(error =>{
            console.error(error)
            if (errorCallback)
                errorCallback('Problème de chargement… Réessayez plus tard ou contactez nous :)')
        })
    }
    getFile (url, callback=null, errorCallback=null) {
        fetch(this._radioHost + url)
        .then(response => response.text())
        .then(data => {
            callback(data)
        })
        .catch(error =>{
            console.error(error)
            if (errorCallback)
                errorCallback('Problème de chargement… Réessayez plus tard ou contactez nous :)')
        })
    }
}


export function omaInit(config) {
    const httpHost =  (config.ssl ? 'https://' : 'http://') + config.radioHost
    const ows = new OmaWebsocketClient((config.ssl ? 'wss://' : 'ws://') + config.radioHost, config.wsPort)
    return {
        radioHost: httpHost,
        ows: ows,
        player: new OmaPlayer(httpHost, ows),
        defaultImage: '/favicon.webp',
    }
}

export function omaInitWrapper(config) {

/* Logger */
//function log (m) {
//    //document.getElementById('logs').innerHTML += m + '<br />';
//    alert('E: ' + m)
//}

/* Catch all errors */
//window.addEventListener("error", function (e) {
//    log('GLOBAL ERROR: '+ e.error.message + '<br/>' + e.toString())
//    console.log(e)
//    return false;
//})
//window.addEventListener('unhandledrejection', function (e) {
//  log("Error occurred: " + e.reason.message + '<br/>' + e.toString() + '<br/>' + JSON.stringify(e, Object.getOwnPropertyNames(e)));
//  console.log(e)
//})


    /* If ogv is needed, wait for lib loading to init player */
    //if (!canPlayOgg && ogvstate == 'loading') {
    //    console.log('On attend le chargement d’ogv');
    //    return new Promise((resolve) => {
    //        ogv_js.onload = () => {
    //            resolve(omaInit(config));
    //        };
    //    });
    //} else {
        return new Promise((resolve) => {
            resolve(omaInit(config));
        })
    //}
}
